import {Injectable} from '@angular/core';
import {ToastService} from "./toast.service";

const CHECK_INTERVAL = 10 * 60 * 1000

/** The hashed main bundle name is the build id: `outputHashing: all` changes it on every prod build. */
export function buildId(html: string): string | null {
  return html.match(/main-[A-Z0-9]+\.js/i)?.[0] ?? null
}

@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {
  private currentBuild = buildId(document.querySelector<HTMLScriptElement>('script[src*="main-"]')?.src ?? '')
  private notified = false

  constructor(
    private toastSvc: ToastService
  ) {}

  start() {
    // No hash in dev (`ng serve` emits plain main.js) — nothing to compare against.
    if (!this.currentBuild) return
    setInterval(() => this.check(), CHECK_INTERVAL)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') this.check()
    })
  }

  private async check() {
    // ponytail: notified once per page life; if another snackbar displaces ours the user
    // only sees it again on their next load. Add a persistent banner if that bites.
    if (this.notified) return
    try {
      const html = await fetch('/index.html', {cache: 'no-store'}).then(r => r.text())
      const latest = buildId(html)
      if (!latest || latest === this.currentBuild) return
      this.notified = true
      this.toastSvc.show('info', 'A new version of Onion is available.',
        {action: {label: 'Refresh', run: () => location.reload()}})
    } catch {
      // offline or hosting hiccup — next tick tries again
    }
  }
}
